/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VirtualServiceModule
 * @preferred
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { AviAlertBellModule } from 'ng/modules/avi-alert-bell/avi-alert-bell.module';
import { AviCardModule } from 'nsx-alb-ui-components';
import { StoreModule } from '@ngrx/store';
import { ClrAlertModule } from '@clr/angular';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { SharedModule } from 'ng/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { MatchModule } from 'ng/modules/match/match.module';
import { DialogModule } from 'ng/modules/dialog/dialog.module';
import { HealthScoreModule } from 'ng/modules/health-score/health-score.module';

import {
    VHMatchRuleModalComponent,
} from 'ng/modules/virtual-service/components/vh-match-rule-modal/vh-match-rule-modal.component';

import { featureKey } from './store/virtual-service.selectors';
import { virtualServiceReducer } from './store/virtual-service.reducer';

import {
    DeleteVsDialogComponent,
    DnsRecordsPageComponent,
    VHMatchModalComponent,
    VHMatchRuleGridComponent,
    VipListPopoverComponent,
    VirtualHostGridComponent,
    VirtualServiceFaultsComponent,
    VsAddressGridCellComponent,
    VsListPageComponent,
    VsSnatIpAddressesComponent,
} from './components';

import { VirtualServiceStateService } from './services';

import {
    dnsQueryCollectionProvider,
    metricDataCollectionProvider,
    virtualServiceCollectionProvider,
} from './ajs-upgraded-providers';

const virtualServiceComponents = [
    DeleteVsDialogComponent,
    DnsRecordsPageComponent,
    VirtualHostGridComponent,
    VHMatchModalComponent,
    VHMatchRuleModalComponent,
    VHMatchRuleGridComponent,
    VirtualServiceFaultsComponent,
    VsSnatIpAddressesComponent,
    VsListPageComponent,
    VsAddressGridCellComponent,
    VipListPopoverComponent,
];

@NgModule({
    declarations: [
        ...virtualServiceComponents,
    ],
    providers: [
        VirtualServiceStateService,
        metricDataCollectionProvider,
        dnsQueryCollectionProvider,
        virtualServiceCollectionProvider,
    ],
    imports: [
        AviAlertBellModule,
        AviCardModule,
        AviFormsModule,
        BrowserAnimationsModule,
        ClrAlertModule,
        CommonModule,
        DataGridModule,
        MatchModule,
        SharedModule,
        StoreModule.forFeature(featureKey, virtualServiceReducer),
        DialogModule,
        HealthScoreModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class VirtualServiceModule {}
